import { forwardRef, Input } from '@heroui/react'
import { Controller, useFormContext } from 'react-hook-form'
import SMSNumbersSelect from './SMSNumberSelect'

const VoicemailSMSInput = forwardRef((props, _ref) => {
  const { name, label = 'Voicemail SMS', description = 'When the AI encounters a voicemail, it will send a SMS to the user with the message below, after the beep.' } = props
  const { control } = useFormContext()

  return (
    <div className="flex flex-col gap-3 border border-gray-200 p-3">
      <div className="flex flex-col gap-1">
        {label && <label className="text-small font-medium text-foreground">{label}</label>}
        {description && <p className="text-tiny text-foreground-400">{description}</p>}
      </div>

      <div className="flex flex-col gap-3">
        <Controller
          name={`${name}.from`}
          control={control}
          render={({ field }) => (
            <SMSNumbersSelect
              {...field}
            />
          )}
        />

        <Controller
          name={`${name}.message`}
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              label="Message"
              labelPlacement="outside"
              variant="bordered"
              radius="sm"
              placeholder="Hey there, I'm from Bland AI, and just gave you a ring. Let me know when you're free to chat!"
              description="The message to send when a voicemail is detected"
            />
          )}
        />
      </div>
    </div>
  )
})

export default VoicemailSMSInput
